import React from 'react';
import PropTypes from 'prop-types';

import styles from './Tag.scss';

export default function Tag(props) {
    const {onDelete, id, value, withoutDeletion} = props;

    const handleDeleteTag = () => {
        onDelete(id);
    };

    return (
        <div className={styles.tag}>
            {value}
            {!withoutDeletion && <button className={styles.deleteButton} onClick={handleDeleteTag}/>}
        </div>
    )
}

Tag.propTypes = {
    value: PropTypes.string,
    id: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    withoutDeletion:  PropTypes.bool,
};

Tag.defaultProps = {
    value: '',
};




// WEBPACK FOOTER //
// ./src/components/controls/Tag.jsx